import "../styles/education.css";
import dit from "../images/dit_logo.jpg";
import pyds from "../images/pyds_logo.png";

import { HiBadgeCheck } from "react-icons/hi";

export default function Education() {
	return (
		<section className="education section" id="education">
			<span className="section__subtitle">Education & Skills</span>
			<h2 className="section__title">My Education</h2>
			<div className="education_skills">
				<div className="hundred">
					<div className="education__Mtitle_container">
						<h3 className="education__Mtitle">Education</h3>
					</div>
					<div className="education__container">
						<div className="education__card">
							<img src={dit} alt="" className="education__logo" />
							<div className="education__data">
								<h3 className="education__title">DIT University</h3>
								<p className="education__subtitle">Bachelor of Technology</p>
								<p className="education__subsubtitle">
									in Computer Science Eng.
								</p>
								<p className="education__duration">2021 - Present</p>
							</div>
						</div>
						<div className="education__card">
							<img src={pyds} alt="" className="education__logo" />
							<div className="education__data">
								<h3 className="education__title">PYDS Learning Academy</h3>
								<p className="education__subtitle">
									Higher Secondary Education
								</p>
								<p className="education__subsubtitle">
									with PCM & Computer Science
								</p>
								<p className="education__duration">2019 - 2021</p>
							</div>
						</div>
					</div>
				</div>
				<div className="hundred">
					<div className="education__Mtitle_container">
						<h3 className="education__Mtitle">Skills</h3>
					</div>
					<div className="skills__content">
						<h3 className="skills__title">Skills</h3>

						<div className="skills__box">
							<div className="skills__groups">
								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">React JS</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>

								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">Node JS</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>

								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">Machine Learning</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>
							</div>

							<div className="skills__groups">
								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">Java</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>

								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">Arduino</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>

								<div className="skills__data">
									<HiBadgeCheck className="skills_badge" />

									<div>
										<h3 className="skills__name">Flutter</h3>
										<span className="skills__level">Intermediate</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
